import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_G01ItemListGroupHeader = _resolveComponent("G01ItemListGroupHeader")!
  const _component_G01ItemList = _resolveComponent("G01ItemList")!
  const _component_G01ItemCarousel = _resolveComponent("G01ItemCarousel")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'ex-' + _ctx.categoryId,
    class: "p-g01-item-list-group"
  }, [
    _createVNode(_component_G01ItemListGroupHeader, {
      id: _ctx.categoryId,
      label: _ctx.categoryLabel,
      "is-category": _ctx.isCategory,
      "is-first": _ctx.isFirst
    }, null, 8, ["id", "label", "is-category", "is-first"]),
    _createElementVNode("template", null, [
      (_ctx.isSp)
        ? (_openBlock(), _createBlock(_component_G01ItemList, {
            key: 0,
            items: _ctx.items,
            "list-name": _ctx.categoryId,
            "is-category": _ctx.isCategory,
            class: "p-g01-item-list-group__list"
          }, null, 8, ["items", "list-name", "is-category"]))
        : (_openBlock(), _createBlock(_component_G01ItemCarousel, {
            key: 1,
            items: _ctx.items,
            "carousel-name": _ctx.categoryId,
            class: "p-g01-item-list-group__carousel"
          }, null, 8, ["items", "carousel-name"]))
    ])
  ], 8, _hoisted_1))
}